// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import IconButton from '@mui/material/IconButton'
import CheckIcon from '@mui/icons-material/CheckCircle'
import classnames from 'classnames'
import React, { PureComponent } from 'react'
import css from './ChecklistButton.css'

type Props = {
  timePeriod: string | number
  isChecked: boolean
  check: (...args: Array<any>) => any
  callback: (...args: Array<any>) => any
  date: string
  isLocked: boolean
}

export default class ChecklistButton extends PureComponent<Props> {
  constructor() {
    super()
    this.state = {
      isUndoable: false,
    }
    this.undoTimeout = null
  }

  componentWillUnmount() {
    if (this.undoTimeout) {
      clearTimeout(this.undoTimeout)
    }
  }

  onClick = () => {
    const { date, timePeriod, isChecked, check, callback } = this.props
    check(date, timePeriod, isChecked, callback)

    if (!isChecked) {
      this.setState(
        {
          isUndoable: true,
        },
        () => {
          this.undoTimeout = setTimeout(
            () =>
              this.setState({
                isUndoable: false,
              }),
            30000,
          )
        },
      )
    } else {
      this.setState(
        {
          isUndoable: false,
        },
        () => clearTimeout(this.undoTimeout),
      )
    }
  }

  render() {
    const { isChecked, isLocked } = this.props
    const { isUndoable } = this.state
    // Not allowed user to click if it is either locked or already checked and it's not undoable
    const isNotClickable = (isLocked || isChecked) && !isUndoable
    return (
      <IconButton
        className={classnames(css.button, {
          [css.checked]: isChecked,
          [css.notChecked]: !isChecked,
          [css.notClickable]: isNotClickable,
          [css.blur]: isLocked && !isChecked,
          [css.undoable]: isUndoable,
        })} // Prevent user to uncheck
        onClick={isNotClickable ? undefined : this.onClick}
      >
        <CheckIcon />
      </IconButton>
    )
  }
}
